import {createSelector} from 'reselect'
import {State} from 'lib/store'
import {DialogState} from './reducer'

const selectFeature = (state: State): DialogState => state.dialog

export const getId = createSelector(selectFeature, dialog => dialog.id)
